// Simple landing hub for the restricted `leads_viewer` role.
// Shows the two links they can access + a Sign Out button.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Link2, LogOut, ArrowRight } from 'lucide-react';

const TILES = [
  {
    to: '/derwent-links-admin',
    label: 'Derwent Links Admin',
    desc: 'Manage the public Derwent Links page & analytics',
    Icon: Link2,
  },
];

const LeadsViewerHub = () => {
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen" style={{ background: '#1d1d1d' }} data-testid="leads-viewer-hub">
      <div className="max-w-3xl mx-auto px-6 py-14 sm:py-20">
        <div className="flex items-center justify-between gap-4 mb-10">
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-[0.28em] font-bold text-white/50">Welcome back</p>
            <h1 className="text-2xl sm:text-3xl font-black text-white mt-1 truncate">
              {user?.name || 'Viewer'}
            </h1>
          </div>
          <button
            onClick={handleLogout}
            data-testid="leads-viewer-logout"
            className="shrink-0 inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-white/10 hover:bg-white/20 text-white text-sm font-bold transition-colors ring-1 ring-white/15"
          >
            <LogOut className="w-4 h-4" /> Sign out
          </button>
        </div>

        <p className="text-white/70 text-sm mb-6">Choose where you&apos;d like to go:</p>

        <div className="grid gap-4 sm:grid-cols-2">
          {TILES.map(({ to, label, desc, Icon }) => (
            <button
              key={to}
              onClick={() => navigate(to)}
              data-testid={`leads-viewer-tile-${to.replace(/\//g, '')}`}
              className="text-left group rounded-3xl p-6 bg-[#f4f4f4] hover:bg-white transition-colors flex flex-col gap-4 min-h-[180px] shadow-lg"
            >
              <div className="w-12 h-12 rounded-2xl bg-[#1d1d1d] flex items-center justify-center">
                <Icon className="w-6 h-6 text-white" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-black text-[#1d1d1d] leading-tight">{label}</h3>
                <p className="text-[13px] text-[#1d1d1d]/65 mt-1 leading-snug">{desc}</p>
              </div>
              <span className="inline-flex items-center gap-1.5 text-xs font-bold text-[#1d1d1d] group-hover:translate-x-1 transition-transform">
                Open <ArrowRight className="w-3.5 h-3.5" />
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default LeadsViewerHub;
